import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email"]

  // outlet API: read by billing_profile_toggle_controller via the users--account outlet
  get email() {
    return this.emailTarget.value
  }
}
